import { BUTTON_SIZE, DSButton } from '@repo/design-system/index'
import { useState } from 'react'
import apis from '../../../modules/apis'
import { n_purchase } from '../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../modules/i18n/useTranslation'
import urls from '../../../modules/urls'
import PaymentStripeForm from '../../student/portal/pricing/PaymentStripeForm'
import { IPurchasePayload } from './ContentTypeUtils'

const StripePaymentModalBody = ({ contentType, id, price }) => {
  const { t, locale } = useTranslation()

  const createUrl = apis.contentPrograms.purchase()
  const errorRedirectUrl = (id, errorMsg) => urls.student.newPortal.study.readPricing.fail(id, true, errorMsg)
  const clientSecretUrl = (id) => apis.contentPrograms.createStripeClientSecret(id) // purchase_id를 실제 값으로 대체해야 함
  const returnUrl = `${window.location.origin}/${locale}/portal/study/read-pricing/waiting` // 적절한 경로로 설정

  const [submitStripeForm, setSubmitStripeForm] = useState<boolean>(false) // for executing stripe payment
  const [stripeAmount, setStripeAmount] = useState('')
  const [stripeLoading, setStripeLoading] = useState<boolean>(false)

  const stripePayload: IPurchasePayload = {
    sanity_content_type: contentType,
    sanity_id: id,
    transaction_type: 'stripe',
    amount: price,
    currency: 'usd',
  }

  return (
    <div>
      <PaymentStripeForm
        payload={stripePayload}
        createUrl={createUrl}
        errorRedirectUrl={errorRedirectUrl}
        clientSecretUrl={clientSecretUrl}
        returnUrl={returnUrl}
        submitStripeForm={submitStripeForm}
        setSubmitStripeForm={setSubmitStripeForm}
        setStripeAmount={setStripeAmount}
        stripeLoading={stripeLoading}
        setStripeLoading={setStripeLoading}
      />
      <hr className="mt-[32px] mb-[24px]" />
      <div className="mt-[20px]">
        <div className="flex flex-row justify-between">
          <div className="">
            <span className="Body1-16Bd  whitespace-nowrap">{t(n_purchase.subtotal.total)}</span>
          </div>
          <div className="flex justify-end flex-col">
            <div className="text-purple-500 Headline1-28Bd flex justify-end">${stripeAmount}</div>
            <div className="flex justify-end">
              <div className="Body2-14Md flex flex-row">
                <div className="text-gray-500 text-right whitespace-nowrap">
                  <span className="text-red-500 text-right">*</span>
                  {t(n_purchase.subtotal.explanation_usd)}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className=""></div>
      </div>
      <hr className="mt-[24px] mb-[20px]" />
      <div className="flex justify-center">
        <span className="Body2-14Md text-gray-500 text-center">{t(n_purchase.subtotal.agreement)}</span>
      </div>
      <div className="mt-[20px]">
        <DSButton onClick={() => setSubmitStripeForm(true)} size={BUTTON_SIZE.LG} isLoading={stripeLoading}>
          <DSButton.Label>{t(n_purchase.btn_submit_order)}</DSButton.Label>
        </DSButton>
      </div>
    </div>
  )
}

export default StripePaymentModalBody
